import { css } from '@fable/theme'
import errorCardModalPayload from '../../../../components/error_card/errorCardModalPayload'
import { Button } from '@fable/components'
import { useActions, useTypedSelector } from '../../../../hooks'
import { useFeaturedEvent } from '../../context'

export const FeaturedEventRSVPButton: React.VFC = () => {
  const { event, registerUserToEvent, registering, registrationStatus } =
    useFeaturedEvent()
  const { openModal } = useActions()
  const registered = !!registrationStatus.data
  const joinText = !event.joinLink ? 'RSVP Confirmed' : 'Launch Zoom Event'
  const noJoinLink = registered && !event.joinLink
  const modal = useTypedSelector(({ modal }) => modal)

  const openZoomLink = () => {
    window.open(event.joinLink, '_blank')
  }

  const handleRSVP = () => {
    if (!event.eventId || event.eventId === '') return null
    registerUserToEvent()
  }

  if (registering.error) {
    if (!modal?.isOpen) {
      const { content, modalType } = errorCardModalPayload()
      openModal(content, modalType)
    }
    return <div />
  }

  return (
    <>
      <Button
        dataTestId="event-rsvp-button"
        className={css`
          margin-top: 36px;
        `}
        height="48px"
        label={registered ? joinText : 'RSVP'}
        width="100%"
        onClick={registered ? openZoomLink : handleRSVP}
        loading={registering.loading || registrationStatus.loading}
        inverted={event.theme === 'dark'}
        disabled={noJoinLink}
        custom={
          !!event.rsvpButtonColor && {
            backgroundColor: event.rsvpButtonColor,
            borderColor: event.rsvpButtonColor,
          }
        }
      />
    </>
  )
}
